import { render, staticRenderFns } from "./ModelGoalsCard.vue?vue&type=template&id=7579c6d4"
import script from "./ModelGoalsCard.vue?vue&type=script&lang=js"
export * from "./ModelGoalsCard.vue?vue&type=script&lang=js"
import style0 from "./ModelGoalsCard.vue?vue&type=style&index=0&id=7579c6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports